import { FeatureFlagVariationValue, JSONValue } from '@moda/portal-stanchions';

export type NavLinkItem = { label: string; url: string };
export type NavLinksFlagValue = { items: NavLinkItem[] } | null;

const SAFE_URL_PATTERN = /^(\/(?!\/)|#|https?:\/\/)/i;

export const isSafeNavUrl = (url: string): boolean => SAFE_URL_PATTERN.test(url);

const isNavLinkItem = (value: JSONValue): value is NavLinkItem =>
  value != null &&
  typeof value === 'object' &&
  !Array.isArray(value) &&
  'label' in value &&
  typeof value.label === 'string' &&
  value.label.trim() !== '' &&
  'url' in value &&
  typeof value.url === 'string' &&
  isSafeNavUrl(value.url);

export const isNavLinksFlagValue = (
  value: FeatureFlagVariationValue
): value is NonNullable<NavLinksFlagValue> =>
  value != null &&
  typeof value === 'object' &&
  !Array.isArray(value) &&
  'items' in value &&
  Array.isArray(value.items) &&
  value.items.length > 0 &&
  value.items.every(isNavLinkItem);
